import { Injectable } from '@angular/core';

// This service is created because the drag event.dataTransfer.setData and
// event.dataTransfer.getData have annoying security policies that prevent
// identifying the object before it is dropped in Chrome specifically.

export type TaskDragData = {
  type: 'task';
  orgId: string;
  spaceId: string;
  taskId: string;
  listId: string; // source listId
  contextDepth: number;
};

@Injectable({ providedIn: 'root' })
export class DragService {
  private data: undefined | TaskDragData;

  constructor() {
    //
  }

  setData(data: undefined | TaskDragData) {
    this.data = data;
  }

  getData() {
    return this.data;
  }
}
